import { selectUser, useAuthStore } from '@client/stores/AuthStore';

type User = NonNullable<ReturnType<typeof selectUser>>;

export function useUser<T extends boolean = true>(options?: {
    throwOnUndefined?: T;
}): T extends true ? User : User | undefined {
    const user = useAuthStore(selectUser);

    if (!user && options?.throwOnUndefined !== false) {
        throw new Error('useUser: User is undefined.');
    }

    return user!;
}
